import { useEffect } from 'react';

// Add Chatwoot Settings
window.chatwootSettings = {
  hideMessageBubble: false,
  position: 'right', // This can be left or right
  locale: 'en', // Language to be set
  type: "expanded_bubble", // [standard, expanded_bubble]
  launcherTitle: "Soporte técnico",
};

/**
 *
 * @param {*} props
 * @returns
 */
function ChatwootWidget (props) {
  useEffect(() => {
    const env = window.appEnv
    const account = props
      ? props.account
      : undefined

    const baseUrl = env && env.support ? env.support.url : undefined;
    if (!baseUrl) {
      return
    }

    const websiteToken = window.appEnv && window.appEnv.support
      ? window.appEnv.support.token
      : undefined

    let script = document.getElementById("chatwootScript")
    if (!script) {
      const firstScript = document.getElementsByTagName("script")[0];
      script = document.createElement("script")
      script.id = "chatwootScript"
      script.src = `${baseUrl}/packs/js/sdk.js`;
      script.async=!0;
      script.onload = function() {
        window.chatwootSDK.run({
          websiteToken,
          baseUrl
        })

        if (account && account.sMail) {
          window.$chatwoot.setUser({
            email: account.sMail,
            name: account.sRazonSocial,
            // avatar_url: ,
            phone_number: account.sTelefono,
          })
        }
      }

      firstScript.parentNode.insertBefore(script, firstScript);
    }

  }, [props])

  return null;
}

export default ChatwootWidget
